"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames2 = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CSS_PREFIX = 'vds-card';
var CSS_STATE = 'vds-state';

var Card = function Card(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      state = _ref.state,
      type = _ref.type,
      remainingProps = _objectWithoutProperties(_ref, ["children", "className", "state", "type"]);

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames2.default)((_classnames = {}, _defineProperty(_classnames, "".concat(CSS_PREFIX, "--").concat(type), Boolean(type)), _defineProperty(_classnames, "".concat(CSS_STATE, "--").concat(state), Boolean(state)), _classnames), className)
  }, remainingProps), children);
};

Card.propTypes = {
  /**
  * @ignore
  */
  children: _propTypes.node,

  /**
   * @ignore
   */
  className: _propTypes.string,

  /**
   * State
   */
  state: (0, _propTypes.oneOf)(['error', 'success']),

  /**
   * Type
   */
  type: (0, _propTypes.oneOf)(['content', 'content--mini', 'dashboard', 'dashboard--mini'])
};
Card.displayName = 'Card';
var _default = Card;
exports.default = _default;